import { SHINE_START_STATUS } from '@shinetools/shine-start-library';

import { VerificationStepStatus } from 'features/Onboarding/legacy/components/VerificationStep/types';

import {
  ShineStartStepStatus,
  VerificationHomeQueryResults,
} from '../useVerificationQuery/types';
import { ContextSpecificStepStatus } from './types';

const SHINE_START_HAS_COMPANY = [
  SHINE_START_STATUS.SENT_TO_STATE,
  SHINE_START_STATUS.COMPANY_REGISTERED,
];

const STEP_TO_VERIFICATION_STATUS_MAP: Record<
  ShineStartStepStatus,
  VerificationStepStatus
> = {
  error: 'error',
  none: 'waiting',
  pending: 'pending',
  success: 'complete',
};

const getShineStartStepStatus = (
  data?: VerificationHomeQueryResults,
): ContextSpecificStepStatus => {
  if (!data) {
    return 'not-shown';
  }

  if (
    !data.viewer.company.isShineStart ||
    data.viewer.company.shineStart === null ||
    data.viewer.company.shineStart === undefined
  ) {
    return 'not-shown';
  }

  const { status, stepStatus } = data.viewer.company.shineStart;

  if (SHINE_START_HAS_COMPANY.includes(status)) {
    return 'complete';
  }

  return STEP_TO_VERIFICATION_STATUS_MAP[stepStatus];
};

export default getShineStartStepStatus;
